import { useState, useEffect } from 'react';
import { shiftFetch, shiftFetchByRegion } from 'fetch/shiftFetch';
import { reqStatus, Region } from 'types/orderTypes';
import dayjs, { Dayjs } from 'dayjs';
import { ReqEnum } from 'const/requestStatus';
import { ShiftCourierWithDateJson } from '../const/ShiftConst';

const DATE_FORMAT = 'YYYY-MM-DD';

export function useFetchShiftByRegion(
  startDate: Dayjs,
  endDate: Dayjs,
  region: Region,
  timeWhenLastUpdated?: string
): [ShiftCourierWithDateJson[], reqStatus] {
  const [fetchStatus, setFetchStatus] = useState<reqStatus>(ReqEnum.INIT);
  const [shiftCourierWithDateList, setShiftCourierWithDateList] = useState<
    ShiftCourierWithDateJson[]
  >([]);

  const start = dayjs(startDate).format(DATE_FORMAT);
  const end = dayjs(endDate).format(DATE_FORMAT);

  useEffect(() => {
    setFetchStatus(ReqEnum.PENDING);
    const fetchShiftAsync = async (start: string, end: string) => {
      const shiftList: ShiftCourierWithDateJson[] = await shiftFetchByRegion(
        start,
        end,
        region
      );

      setShiftCourierWithDateList(shiftList);
      setFetchStatus(ReqEnum.SUCCESS);
    };
    fetchShiftAsync(start, end);
  }, [start, end, region, timeWhenLastUpdated]);

  return [shiftCourierWithDateList, fetchStatus];
}

export function useFetchAllShift(
  startDate: Dayjs,
  endDate: Dayjs
): [ShiftCourierWithDateJson[], reqStatus] {
  const [fetchStatus, setFetchStatus] = useState<reqStatus>(ReqEnum.INIT);
  const [shiftCourierWithDateList, setShiftCourierWithDateList] = useState<
    ShiftCourierWithDateJson[]
  >([]);

  const start = dayjs(startDate).format(DATE_FORMAT);
  const end = dayjs(endDate).format(DATE_FORMAT);

  useEffect(() => {
    setFetchStatus(ReqEnum.PENDING);
    const fetchShiftAsync = async (start: string, end: string) => {
      const shiftList: ShiftCourierWithDateJson[] = await shiftFetch(
        start,
        end
      );

      setShiftCourierWithDateList(shiftList);
      setFetchStatus(ReqEnum.SUCCESS);
    };
    fetchShiftAsync(start, end);
  }, [start, end]);

  return [shiftCourierWithDateList, fetchStatus];
}
